<script setup>
defineProps({
  status: {
    type: String,
    default: 'progress',
    validator(value) {
      // The value must match one of these strings
      return ['success', 'error', 'progress'].includes(value)
    },
  },
})
</script>

<template>
  <!-- Found here: https://codepen.io/noeldelgado/pen/AWGLbd -->
  <div class="stage -mt-8 -ml-6 -mb-6" v-if="status === 'progress'">
    <ul>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
    </ul>
    <div class="band"></div>
    <div class="factory">
      <div class="magic"></div>
      <div class="screen"></div>
    </div>
  </div>

  <!-- Found here: https://codepen.io/geluk/pen/yLBjgrv -->
  <div v-else class="h-fit mr-10">
    <svg
      v-if="status === 'success'"
      class="checkmark success"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 52 52"
    >
      <circle class="checkmark_circle_success" cx="26" cy="26" r="25" fill="none" />
      <path
        class="checkmark_check"
        fill="none"
        d="M14.1 27.2l7.1 7.2 16.7-16.8"
        stroke-linecap="round"
      />
    </svg>

    <svg
      v-else-if="status === 'error'"
      class="checkmark error"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 52 52"
    >
      <circle class="checkmark_circle_error" cx="26" cy="26" r="25" fill="none" />
      <path
        class="checkmark_check"
        stroke-linecap="round"
        fill="none"
        d="M16 16 36 36 M36 16 16 36
  "
      />
    </svg>
  </div>
</template>

<style>
.stage {
  overflow: hidden;
  position: relative;
  width: 480px;
  height: 175px;
}

.factory {
  position: absolute;
  width: 50px;
  height: 100px;
  background: #e6c747;
  transform: translate(25px, 50px);
}
.factory::before {
  background: #c6a41b;
  border-radius: 1px;
  width: 55px;
  height: 5px;
  top: -5px;
  left: -3px;
}
.factory::after {
  width: 10px;
  height: 10px;
  top: 5px;
  left: 5px;
  border-radius: 50%;
  background-color: #c96160;
}

.magic {
  background: #b8e3f0;
  width: 20px;
  height: 22px;
  position: absolute;
  border-radius: 0 0 3px 3px;
  transform: translate(0, -30px);
}
.magic::before {
  background: #af9218;
  bottom: -3px;
  left: 20%;
  width: 60%;
  height: 3px;
}
.magic::after {
  background: #27af61;
  border-radius: 0 0 4px 4px;
  bottom: 2px;
  left: 2px;
  width: 16px;
  height: 70%;
  animation: upDown 8000ms linear infinite normal;
}

.screen {
  width: 30px;
  height: 25px;
  background-color: #415060;
  position: absolute;
  border-radius: 5px;
  border: 3px solid #fbf7e4;
  transform: translate(7px, 30px);
  overflow: hidden;
}
.screen::before,
.screen::after {
  top: 0;
  left: 0;
  width: 20px;
  height: 20px;
  box-shadow: inset 0 0 0 1px rgba(76, 215, 135, 0.2);
  background-color: rgba(76, 215, 135, 0.1);
  transform: translate(-100px, 0px);
  animation: moveRightPseudo 1000ms linear infinite normal;
}

.band {
  position: absolute;
  width: 175px;
  height: 7px;
  background: #364451;
  border-radius: 8px;
  transform: translate(25px, 105px);
}
.band::before {
  background-image: radial-gradient(#4b5d6f 40%, rgba(0, 0, 0, 0) 41%);
  background-size: 7px 7px;
  background-position: 0px 0px;
  width: 90%;
  height: 7px;
  top: 0px;
  right: 3px;
  z-index: 2;
  animation: band 3600ms linear infinite normal;
}
.band::after {
  background: #4b5d6f;
  width: 79%;
  height: 38px;
  top: 7px;
  left: 28px;
  transform: skew(-15deg);
}

.stage ul {
  position: absolute;
  margin: 0;
  padding: 0;
  width: 210px;
  height: 70px;
  overflow: hidden;
  transform: translate(25px, 80px);
}
.stage ul:after {
  background: #415060;
  border-radius: 50%;
  width: 30px;
  height: 5px;
  bottom: 0px;
  right: 10px;
  z-index: 0;
}

.stage li {
  overflow: hidden;
  z-index: 1;
  position: absolute;
  width: 20px;
  height: 20px;
  background-color: #cf7473;
  transform: translate(0px, 5px);
  transform-origin: center bottom;
  animation-name: moveRight;
  animation-duration: 5000ms;
  animation-timing-function: linear;
  animation-direction: normal;
  animation-iteration-count: infinite;
}
.stage li::after {
  display: block;
  width: 12px;
  height: 3px;
  background-color: #c34e4d;
  top: 2px;
  left: 2px;
}

.stage li:nth-child(1) {
  animation-delay: 0ms;
}

.stage li:nth-child(2) {
  animation-delay: 1000ms;
}

.stage li:nth-child(3) {
  animation-delay: 2000ms;
}

.stage li:nth-child(4) {
  animation-delay: 3000ms;
}

.stage li:nth-child(5) {
  animation-delay: 4000ms;
}

.ps,
.factory::before,
.factory::after,
.magic::before,
.magic::after,
.screen::before,
.screen::after,
.band::before,
.band::after,
ul:after,
li::after {
  content: '';
  position: absolute;
}

@keyframes moveRight {
  0% {
    transform: translate(0px, 5px);
  }
  80% {
    transform: translate(162px, 5px);
  }
  90% {
    transform: translate(165px, 6px) rotateZ(90deg);
  }
  100% {
    transform: translate(170px, 55px) rotateZ(135deg);
  }
}
@keyframes moveRightPseudo {
  0% {
    transform: translate(-25px, 3px);
  }
  100% {
    transform: translate(30px, 3px);
  }
}
@keyframes upDown {
  0% {
    height: 70%;
  }
  70% {
    height: 5%;
  }
  100% {
    height: 70%;
  }
}
@keyframes band {
  0% {
    background-position: 0px 0px;
  }
  100% {
    background-position: 100% 0px;
  }
}

/* Success and error checkmarks */
.checkmark_circle_success {
  stroke-dasharray: 166;
  stroke-dashoffset: 166;
  stroke-width: 5px;
  stroke-miterlimit: 10;
  stroke: #00c851;
  animation: stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;
}

.checkmark_circle_error {
  stroke-dasharray: 166;
  stroke-dashoffset: 166;
  stroke-width: 5px;
  stroke-miterlimit: 10;
  stroke: #ff4444;
  animation: stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;
}

.checkmark {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  display: block;
  stroke-width: 5px;
  stroke: white;
  stroke-miterlimit: 10;
}
.checkmark.success {
  box-shadow: inset 0px 0px 0px #00c851;
  animation:
    fillsuccess 0.4s ease-in-out 0.4s forwards,
    scale 0.3s ease-in-out 0.9s both;
}
.checkmark.error {
  box-shadow: inset 0px 0px 0px #ff4444;
  animation:
    fillerror 0.4s ease-in-out 0.4s forwards,
    scale 0.3s ease-in-out 0.9s both;
}

.checkmark_check {
  transform-origin: 50% 50%;
  stroke-dasharray: 48;
  stroke-dashoffset: 48;
  animation: stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.9s forwards;
}

.progress {
  transform: rotate(-90deg);
  stroke: black;
}

.progress circle {
  stroke-dasharray: 130;
  stroke-dashoffset: 130;
  animation: dash 1.5s infinite;
}

@keyframes dash {
  50% {
    stroke-dashoffset: 0;
  }
  100% {
    stroke-dashoffset: -130;
  }
}
.progress {
  position: absolute;
  top: 5%;
  left: 5%;
}
.progress.progress--thin {
  left: auto;
  right: 5%;
}

@keyframes stroke {
  100% {
    stroke-dashoffset: 0;
  }
}
@keyframes scale {
  0%,
  100% {
    transform: none;
  }
  50% {
    transform: scale3d(1.1, 1.1, 1);
  }
}
@keyframes fillsuccess {
  100% {
    box-shadow: inset 0px 0px 0px 75px #00c851;
  }
}
@keyframes fillerror {
  100% {
    box-shadow: inset 0px 0px 0px 75px #ff4444;
  }
}
</style>
